
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir/manage",
      function () {
        return require("private-next-pages/ir/manage/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ir/manage"])
      });
    }
  